var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#9CA3AF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6504 8.99186C20.4339 8.99831 20.2284 9.0888 20.0775 9.24414L11.5 17.8216L8.75589 15.0775C8.6791 14.9975 8.58713 14.9336 8.48535 14.8897C8.38358 14.8457 8.27405 14.8224 8.16318 14.8213C8.05232 14.8202 7.94234 14.8412 7.83969 14.8831C7.73704 14.925 7.64379 14.987 7.56539 15.0654C7.48699 15.1438 7.42502 15.237 7.38312 15.3397C7.34121 15.4423 7.3202 15.5523 7.32133 15.6632C7.32246 15.774 7.3457 15.8836 7.38969 15.9853C7.43367 16.0871 7.49753 16.1791 7.5775 16.2559L10.9108 19.5892C11.0671 19.7454 11.2791 19.8332 11.5 19.8332C11.721 19.8332 11.9329 19.7454 12.0892 19.5892L21.2559 10.4225C21.3763 10.3055 21.4586 10.1548 21.4919 9.99017C21.5252 9.82557 21.508 9.65475 21.4425 9.5001C21.377 9.34545 21.2664 9.21417 21.1251 9.12348C20.9837 9.03279 20.8183 8.98691 20.6504 8.99186Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxFilled);
export default __webpack_public_path__ + "static/media/checkbox-filled.5dd865f8d949ff2cb41223228acb2eb2.svg";
export { ForwardRef as ReactComponent };